import DashbordCheckInOut from './DashbordCheckInOut'
import DashbordLeave from './DashbordLeave'
import DashbordResign from './DashbordResign'
import DashbordPosition from './DashbordPosition'
import DashbordCovid from './DashbordCovid'
import DashBoardView from './DashBoardView'
import DashBoardViewEducationLevelEmp from './DashBoardViewEducationLevelEmp'
import DashBoardViewRegionEmp from './DashBoardViewRegionEmp'
import DashBoardStatusEmp from './DashBoardStatusEmp'
import DashBoardLocation from './DashBoardLocation'
import DashBoardLeave from './DashBoardLeave'
import DashBoardAgeRangeEmp from './DashBoardAgeRangeEmp'
import DashBoardAdjustINOUT from './DashBoardAdjustINOUT'
import DashBoardOT from './DashBoardOT'

export default {
  DashbordCheckInOut,
  DashbordLeave,
  DashbordResign,
  DashbordPosition,
  DashbordCovid,
  DashBoardView,
  DashBoardViewEducationLevelEmp,
  DashBoardViewRegionEmp,
  DashBoardStatusEmp,
  DashBoardLocation,
  DashBoardLeave,
  DashBoardAgeRangeEmp,
  DashBoardAdjustINOUT,
  DashBoardOT
}



// WEBPACK FOOTER //
// ./src/components/Dashbord/index.js